import { Chip } from '@mui/material';

/*
  Marks an address on file that no message can be sent to - an email that is not one address with a
  real domain, or a number a text cannot go to (story 15723). The server decides which: each contact
  carries its invalidAddresses (MsgAddresses.Invalid), the same rule the sends refuse by.

  Filled red, unlike the quiet grey Preferred chip beside it: this one is asking for the address to
  be fixed. Sized to sit on the address's line as that one does.
*/
export function InvalidAddressChip({ kind }: { kind: 'email' | 'phone' }) {
  return (
    <Chip
      label={kind === 'email' ? 'Invalid email' : 'Invalid phone#'}
      size="small"
      color="error"
      sx={{ height: 18, fontSize: 10 }}
    />
  );
}
